import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';
import { NavigationItem } from '@telialt/models/src/Navigation';

import { displayOption } from '../Navigation.styles';

export const StyledMenuItemList = styled.div<{ $displayOption?: NavigationItem['displayOption'] }>`
    display: flex;
    gap: 0 ${getPurpurSpacing('200')};
    height: 100%;

    ${({ $displayOption }) => displayOption($displayOption)};
`;
